import * as React from 'react';
import { CustomComponent } from '@narvar/cth';

const CustomComponentContext = React.createContext<CustomComponent>(
  undefined as unknown as CustomComponent,
);

export default CustomComponentContext;
